import { useEffect, useState } from "react";
import Nav from "../components/Nav";
import Footer from "../components/Footer";
import NewsletterBlock from "../components/NewsletterBlock";
import ProfileAvatar from "../components/ProfileAvatar";
import useReveal from "../hooks/useReveal";
import { api } from "../lib/api";

export default function SobreMi() {
  const [author, setAuthor] = useState(null);

  useReveal();

  useEffect(() => {
    api.get("/config/author").then((r) => setAuthor(r.data)).catch(() => {});
  }, []);

  const socials = [
    { key: "twitter_url", label: "Twitter" },
    { key: "instagram_url", label: "Instagram" },
    { key: "github_url", label: "GitHub" },
    { key: "rss_url", label: "RSS" },
  ];

  return (
    <>
      <Nav />
      <header className="page-header" data-testid="sobre-mi-page">
        <div className="container">
          <h1 className="reveal">
            Sobre <em>mí</em>
          </h1>
          <p className="reveal d1">
            Una página para contarte quién está detrás de este cuaderno.
          </p>
        </div>
      </header>

      <section className="section">
        <div className="container" style={{ maxWidth: 760 }}>
          <ProfileAvatar
            className="reveal"
            src={author?.foto_url}
            name={author?.nombre || "Berenice"}
            size={220}
            style={{ margin: "0 auto 40px" }}
            testId="sobre-mi-avatar"
          />
          <div className="article-content reveal d1" style={{ textAlign: "left" }}>
            {author?.bio ? (
              author.bio.split("\n\n").map((p, i) => <p key={i}>{p}</p>)
            ) : (
              <p>
                Escribo para entender mis emociones y las de los demás. Esto
                es <strong>Berenice — Sin Filtro</strong>: un ejercicio
                personal en público. Sin filtros, sin categoría fija. Si algo
                de lo que escribo te acompaña un día cualquiera, con eso basta.
                Puedes escribirme a{" "}
                <a href="mailto:hola@berenice-sinfiltro.blog" style={{ color: "var(--accent)" }}>
                  hola@berenice-sinfiltro.blog
                </a>
                .
              </p>
            )}
          </div>

          <div style={{ marginTop: 48, display: "flex", gap: 10, flexWrap: "wrap" }}>
            {socials.map((s) =>
              author?.[s.key] ? (
                <a
                  key={s.key}
                  href={author[s.key]}
                  target="_blank"
                  rel="noreferrer"
                  className="btn btn-outline btn-sm"
                  data-testid={`sobre-mi-${s.label.toLowerCase()}`}
                >
                  {s.label}
                </a>
              ) : null
            )}
            <a href="mailto:hola@berenice-sinfiltro.blog" className="btn btn-accent btn-sm">
              Escribirme
            </a>
          </div>
        </div>
      </section>

      <NewsletterBlock />
      <Footer />
    </>
  );
}
